import { render, staticRenderFns } from "./UntieServerDialog.vue?vue&type=template&id=01f68bb8&"
import script from "./UntieServerDialog.vue?vue&type=script&lang=js&"
export * from "./UntieServerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports